import { render } from "./PaintingProductionScheduling.vue?vue&type=template&id=0bc0a979&scoped=true"
import script from "./PaintingProductionScheduling.vue?vue&type=script&lang=js"
export * from "./PaintingProductionScheduling.vue?vue&type=script&lang=js"

import "./PaintingProductionScheduling.vue?vue&type=style&index=0&id=0bc0a979&scoped=true&lang=css"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bc0a979"]])

export default __exports__